import { useState } from "react";

import { ServiceChecklistModal, ServiceChecklistsTable } from "modules/PendingChecklistsDashboard/components/ServiceChecklists/components";

import type { Checklist } from "models";
import type { ServicePendingChecklistsGrouped } from "modules/PendingChecklistsDashboard/components/ServiceChecklists/hooks";

type ServiceChecklistsProps = {
  isLoading: boolean;
  checklists?: Checklist[];
  servicePendingChecklistsGrouped?: ServicePendingChecklistsGrouped[];
};

export const ServiceChecklists = ({ isLoading, checklists, servicePendingChecklistsGrouped }: ServiceChecklistsProps) => {
  const [selectedCheckInServiceIdForChecklistModal, setSelectedCheckInServiceIdForChecklistModal] = useState(0);

  return (
    <>
      <ServiceChecklistsTable
        isLoading={isLoading}
        servicePendingChecklistsGrouped={servicePendingChecklistsGrouped}
        handleOpenServicePendingChecklists={(id: number) => setSelectedCheckInServiceIdForChecklistModal(id)}
      />
      <ServiceChecklistModal
        checklists={checklists}
        checkInServiceId={selectedCheckInServiceIdForChecklistModal}
        servicePendingChecklistsGrouped={servicePendingChecklistsGrouped}
        onClose={() => setSelectedCheckInServiceIdForChecklistModal(0)}
      />
    </>
  );
};
